import { useState } from 'react';
import axios from 'axios';
import './InstantBooking.css';

export default function InstantBooking({ open, onClose }) {
  const [form, setForm] = useState({ name: '', address: '', phone: '', service: '', openNow: true });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  if (!open) return null;

  const update = (k) => (e) => setForm(s => ({ ...s, [k]: e.target.type === 'checkbox' ? e.target.checked : e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const payload = { ...form };
      await axios.post('/api/instant', payload);
      setSubmitted(true);
      setTimeout(() => {
        setSubmitted(false);
        onClose();
      }, 4000);
    } catch (err) {
      setError(err?.response?.data?.message || 'Submission failed');
    } finally { setLoading(false); }
  };

  return (
    <div className="ib-overlay" role="dialog" aria-modal="true">
      <div className="ib-modal">
        <button className="ib-close" onClick={onClose} aria-label="Close">×</button>
        {!submitted ? (
          <form className="ib-form" onSubmit={handleSubmit}>
            <h3>Book Instant Service</h3>
            <p className="muted">Fill this form and we'll contact you within 10 minutes.</p>
            <label>
              Name
              <input required value={form.name} onChange={update('name')} />
            </label>
            <label>
              Address
              <input required value={form.address} onChange={update('address')} />
            </label>
            <label>
              Phone
              <input required value={form.phone} onChange={update('phone')} />
            </label>
            <label>
              Nearby Service Requested
              <input required value={form.service} onChange={update('service')} placeholder="e.g. Wound care, IV, Elderly care" />
            </label>
            <label className="ib-check">
              <input type="checkbox" checked={form.openNow} onChange={update('openNow')} /> Open now
            </label>
            {error && <div style={{color:'#b91c1c',marginTop:8}}>{error}</div>}
            <div className="ib-actions">
              <button type="button" className="btn btn-outline" onClick={onClose} disabled={loading}>Cancel</button>
              <button type="submit" className="btn btn-teal" disabled={loading}>{loading ? 'Sending…' : 'Submit'}</button>
            </div>
          </form>
        ) : (
          <div className="ib-confirm">
            <div className="ib-icon">✅</div>
            <h3>Booking Confirmed</h3>
            <p>Thank you — we will contact you within 10 minutes.</p>
            <p className="ib-whatsapp">You can also chat with us on WhatsApp:</p>
            <a className="ib-wa-link" href="https://wa.me/917006188346" target="_blank" rel="noopener noreferrer">💬 Chat on WhatsApp</a>
          </div>
        )}
      </div>
    </div>
  );
}
